// ── Salesforce Users (for agent assignment) ────────────────────────────────
export const mockSalesforceUsers = [
  { id: 'u1', name: 'Sarah Johnson',  role: 'Account Executive', email: 'sarah.johnson@acmecorp.com',   initials: 'SJ' },
  { id: 'u2', name: 'Mike Chen',      role: 'Sales Rep',         email: 'mike.chen@acmecorp.com',       initials: 'MC' },
  { id: 'u3', name: 'Emily Rodriguez',role: 'SDR',               email: 'emily.rodriguez@acmecorp.com', initials: 'ER' },
  { id: 'u4', name: 'David Park',     role: 'Account Executive', email: 'david.park@acmecorp.com',      initials: 'DP' },
  { id: 'u5', name: 'Lisa Thompson',  role: 'Sales Rep',         email: 'lisa.thompson@acmecorp.com',   initials: 'LT' },
  { id: 'u6', name: 'James Wilson',   role: 'SDR',               email: 'james.wilson@acmecorp.com',    initials: 'JW' },
  { id: 'u7', name: 'Rachel Green',   role: 'Account Executive', email: 'rachel.green@acmecorp.com',    initials: 'RG' },
  { id: 'u8', name: 'Tom Martinez',   role: 'Sales Rep',         email: 'tom.martinez@acmecorp.com',    initials: 'TM' },
  { id: 'u9', name: 'Amanda Foster',  role: 'SDR',               email: 'amanda.foster@acmecorp.com',   initials: 'AF' },
  { id: 'u10',name: "Kevin O'Brien",  role: 'Senior AE',         email: 'kevin.obrien@acmecorp.com',    initials: 'KO' },
]

export const PRICE_PER_AGENT = 9
export const DEFAULT_SELECTED_AGENTS = ['u1', 'u2', 'u3', 'u4']

// ── Needs Review Matches ────────────────────────────────────────────────────
// Email domain matches and contact email matches are treated as 100% confidence
// and auto-confirmed (they appear in Matched). Only ambiguous name-similarity
// matches appear here for admin review.
export const initialNeedsReview = [
  {
    id: 'nr1',
    sfAccount: {
      name: 'BrightPath Consulting',
      website: 'brightpathconsulting.com',
      primaryContact: { name: 'Jennifer Walsh', email: 'j.walsh@brightpathconsulting.com' },
      contactCount: 5,
      industry: 'Professional Services',
    },
    stripeCustomer: {
      name: 'Brightpath Consult.',
      email: 'j.walsh@brightpathconsulting.com',
      created: 'Mar 15, 2022',
      totalVolume: '$12,400',
      transactions: 18,
      paymentMethod: 'Visa •••• 4242',
      lastTransaction: 'Jan 18, 2024',
    },
    matchReason: 'Company name 87% similar',
    confidence: 87,
  },
  {
    id: 'nr2',
    sfAccount: {
      name: 'Apex Industrial Supply',
      website: 'apexindustrial.com',
      primaryContact: { name: 'Robert Chen', email: 'r.chen@apexindustrial.com' },
      contactCount: 12,
      industry: 'Manufacturing',
    },
    stripeCustomer: {
      name: 'Apex Industrial Supply LLC',
      email: 'procurement@apexindustrial.com',
      created: 'Jan 8, 2021',
      totalVolume: '$47,800',
      transactions: 32,
      paymentMethod: 'Mastercard •••• 8891',
      lastTransaction: 'Feb 2, 2024',
    },
    matchReason: 'Company name 94% similar',
    confidence: 94,
  },
  {
    id: 'nr6',
    sfAccount: {
      name: 'Summit Healthcare Solutions',
      website: 'summithealth.com',
      primaryContact: { name: 'Dr. Sarah Kim', email: 's.kim@summithealth.com' },
      contactCount: 9,
      industry: 'Healthcare',
    },
    stripeCustomer: {
      name: 'Summit Health Solutions',
      email: 'billing@summithealth.com',
      created: 'Sep 17, 2021',
      totalVolume: '$34,600',
      transactions: 28,
      paymentMethod: 'Mastercard •••• 2289',
      lastTransaction: 'Jan 30, 2024',
    },
    matchReason: 'Company name 89% similar',
    confidence: 89,
  },
  // Multi-match: multiple Stripe candidates found for one SF account
  {
    id: 'nr-multi',
    sfAccount: {
      name: 'Atlas Consulting Group',
      website: 'atlascg.com',
      primaryContact: { name: 'Diana Ross', email: 'd.ross@atlascg.com' },
      contactCount: 8,
      industry: 'Consulting',
    },
    isMultiMatch: true,
    candidates: [
      {
        stripeCustomer: {
          name: 'Atlas Consulting Group LLC',
          email: 'd.ross@atlascg.com',
          created: 'Nov 1, 2023',
          totalVolume: '$7,100',
          transactions: 5,
          paymentMethod: 'Amex •••• 9012',
          lastTransaction: 'Jan 20, 2024',
        },
        confidence: 94,
        matchReason: 'Contact email match',
      },
      {
        stripeCustomer: {
          name: 'Atlas Consulting',
          email: 'billing@atlascg.com',
          created: 'Feb 14, 2022',
          totalVolume: '$18,400',
          transactions: 22,
          paymentMethod: 'Visa •••• 1234',
          lastTransaction: 'Jan 8, 2024',
        },
        confidence: 86,
        matchReason: 'Company name 86% similar + Email domain',
      },
      {
        stripeCustomer: {
          name: 'Atlas CG Inc',
          email: 'accounts@atlascg.com',
          created: 'May 20, 2021',
          totalVolume: '$41,200',
          transactions: 38,
          paymentMethod: 'Mastercard •••• 5678',
          lastTransaction: 'Dec 15, 2023',
        },
        confidence: 82,
        matchReason: 'Email domain match',
      },
    ],
    // Top-level fields for tab count / bulk operations (highest candidate)
    stripeCustomer: null,
    matchReason: 'Multiple Stripe customers found',
    confidence: 94,
  },
]

// ── Unmatched Salesforce Accounts ──────────────────────────────────────────
export const initialUnmatchedSF = [
  { id: 'sf1', name: 'Riverstone Capital',    website: 'riverstonecap.com',       primaryContact: { name: 'Marcus Webb',     email: 'm.webb@riverstonecap.com'      }, industry: 'Finance'         },
  { id: 'sf2', name: 'Pinnacle Marketing Co', website: 'pinnaclemarco.com',        primaryContact: { name: 'Derek Holt',      email: 'd.holt@pinnaclemarco.com'      }, industry: 'Marketing'       },
  { id: 'sf3', name: 'Halcyon Software Inc',  website: 'halcyonsw.com',            primaryContact: { name: 'Nicole Santos',   email: 'n.santos@halcyonsw.com'        }, industry: 'Technology'      },
  { id: 'sf4', name: 'Redwood Staffing Group',website: 'redwoodstaffing.com',      primaryContact: { name: 'Michelle Ford',   email: 'm.ford@redwoodstaffing.com'    }, industry: 'Human Resources' },
  { id: 'sf5', name: 'Ironclad Manufacturing',website: 'ironcladmfg.com',          primaryContact: { name: 'Carl Stevens',    email: 'c.stevens@ironcladmfg.com'     }, industry: 'Manufacturing'   },
  { id: 'sf6', name: 'Pacific Rim Exports',   website: 'pacificrimex.com',         primaryContact: { name: 'Kevin Tanaka',    email: 'k.tanaka@pacificrimex.com'     }, industry: 'Import/Export'   },
  { id: 'sf7', name: 'BlueSky Analytics',     website: 'blueskyanalytics.com',     primaryContact: { name: 'Mia Turner',      email: 'm.turner@blueskyanalytics.com' }, industry: 'Technology'      },
]

// ── Unmatched Stripe Customers ─────────────────────────────────────────────
export const initialUnmatchedStripe = [
  { id: 'sc1', name: 'TechStart Ventures',    email: 'hello@techstart.io',              created: 'Nov 8, 2023',  totalVolume: '$5,200',  lastFour: '9012' },
  { id: 'sc2', name: 'Maple Grove Catering',  email: 'orders@maplegrovecatering.com',   created: 'Jul 14, 2023', totalVolume: '$3,700',  lastFour: '3388' },
  { id: 'sc3', name: 'Northside Auto Parts',  email: 'parts@northsideauto.com',         created: 'Apr 2, 2023',  totalVolume: '$11,400', lastFour: '5567' },
  { id: 'sc4', name: 'Digital Wave Studio',   email: 'studio@digitalwave.co',           created: 'Feb 28, 2023', totalVolume: '$6,800',  lastFour: '2211' },
  { id: 'sc5', name: 'Harbor Point Fitness',  email: 'members@harborpointfitness.com',  created: 'Sep 19, 2023', totalVolume: '$9,100',  lastFour: '8844' },
  { id: 'sc6', name: 'Elena Vasquez',         email: 'elena.vasquez@gmail.com',         created: 'Oct 30, 2023', totalVolume: '$420',    lastFour: '1234' },
  { id: 'sc7', name: 'Pinnacle Mktg',         email: 'billing@pinnaclemarco.com',       created: 'Mar 5, 2022',  totalVolume: '$14,200', lastFour: '6677' },
  { id: 'sc8', name: 'Redwood Staffing',      email: 'invoices@redwoodstaffing.com',    created: 'Aug 11, 2021', totalVolume: '$22,900', lastFour: '4491' },
  { id: 'sc9', name: 'Halcyon SW Ltd',        email: 'billing@halcyonsw.com',           created: 'Jun 3, 2022',  totalVolume: '$31,100', lastFour: '7723' },
]

// Suggested Stripe matches per unmatched SF account id
export const suggestionsMap = {
  'sf2': ['sc7'],   // Pinnacle Marketing Co → Pinnacle Mktg
  'sf4': ['sc8'],   // Redwood Staffing Group → Redwood Staffing
  'sf3': ['sc9'],   // Halcyon Software Inc → Halcyon SW Ltd
}

// ── Confirmed Matched Accounts ─────────────────────────────────────────────
export const initialMatched = [
  { id: 'm1', sfName: 'Meridian Logistics',      stripeName: 'Meridian Logistics',          stripeEmail: 'billing@meridianlogistics.com', method: 'auto',         matchReason: 'Company name exact match',     matchedDate: 'Jan 12, 2024' },
  { id: 'm2', sfName: 'Clearwater Distribution', stripeName: 'Clearwater Distribution Inc', stripeEmail: 'ap@clearwaterdist.com',         method: 'auto',         matchReason: 'Company name exact match',     matchedDate: 'Jan 12, 2024' },
  { id: 'm3', sfName: 'Stellar Communications',  stripeName: 'Stellar Communications',      stripeEmail: 'billing@stellarcomms.com',      method: 'auto',         matchReason: 'Company name exact match',     matchedDate: 'Jan 12, 2024' },
  { id: 'm4', sfName: 'Blackwood & Associates',  stripeName: 'Blackwood Associates',        stripeEmail: 'accounts@blackwoodassoc.com',   method: 'admin_manual', matchReason: 'Admin manually linked',        matchedDate: 'Jan 14, 2024' },
  { id: 'm5', sfName: 'Harmon Property Group',   stripeName: 'Harmon Properties',           stripeEmail: 'billing@harmonproperties.com',  method: 'admin_manual', matchReason: 'Admin manually linked',        matchedDate: 'Jan 15, 2024' },
  { id: 'm6', sfName: 'Crestview Energy',        stripeName: 'Crestview Energy LLC',        stripeEmail: 'ap@crestviewenergy.com',        method: 'agent_manual', matchReason: 'Agent manually linked',        matchedDate: 'Jan 16, 2024' },
  // Auto-confirmed via 100% email matching — not shown in Needs Review
  { id: 'ac1', sfName: 'Coastal Media Group',         stripeName: 'Coastal Media Grp',       stripeEmail: 'contact@coastalmedia.io',          method: 'auto', matchReason: 'Email domain match',           matchedDate: 'Feb 10, 2024' },
  { id: 'ac2', sfName: 'Thornfield Partners',         stripeName: 'Thornfield Partners Ltd', stripeEmail: 'office@thornfieldpartners.com',     method: 'auto', matchReason: 'Email domain match',           matchedDate: 'Feb 10, 2024' },
  { id: 'ac3', sfName: 'Nexus Technology Group',      stripeName: 'nexus technology',        stripeEmail: 'l.park@nexustech.com',             method: 'auto', matchReason: 'Contact email match',          matchedDate: 'Feb 10, 2024' },
  { id: 'ac4', sfName: 'Vanguard Financial Services', stripeName: 'Vanguard Financial Svc',  stripeEmail: 'accounts@vanguardfs.com',          method: 'auto', matchReason: 'Email domain match',           matchedDate: 'Feb 10, 2024' },
  { id: 'ac5', sfName: 'John Mitchell',               stripeName: 'John Mitchell',           stripeEmail: 'john.mitchell@gmail.com',          method: 'auto', matchReason: 'Email match (personal account)', matchedDate: 'Feb 10, 2024' },
]

// ── Widget Search Results (sales rep view) ─────────────────────────────────
export const widgetStripeCustomers = [
  { id: 'ws1', name: 'TechStart Ventures',   email: 'hello@techstart.io',            created: 'Nov 8, 2023',  totalVolume: '$5,200',  transactions: 8,  lastTransaction: 'Jan 30, 2024', paymentMethod: 'Visa •••• 9012'       },
  { id: 'ws2', name: 'Tech Solutions Inc',   email: 'billing@techsolutions.com',     created: 'Aug 3, 2022',  totalVolume: '$38,400', transactions: 41, lastTransaction: 'Feb 10, 2024', paymentMethod: 'Mastercard •••• 4481' },
  { id: 'ws3', name: 'TechForward Group',    email: 'contact@techforward.com',       created: 'May 17, 2023', totalVolume: '$12,700', transactions: 14, lastTransaction: 'Feb 2, 2024',  paymentMethod: 'Visa •••• 3302'       },
  { id: 'ws4', name: 'Apex Industrial',      email: 'ap@apexindustrial.com',         created: 'Jan 8, 2021',  totalVolume: '$91,200', transactions: 78, lastTransaction: 'Feb 14, 2024', paymentMethod: 'Amex •••• 0071'       },
  { id: 'ws5', name: 'Pinnacle Marketing',   email: 'billing@pinnaclemarco.com',     created: 'Mar 5, 2022',  totalVolume: '$14,200', transactions: 19, lastTransaction: 'Jan 22, 2024', paymentMethod: 'Visa •••• 6677'       },
  { id: 'ws6', name: 'Nexus Technology',     email: 'accounts@nexustech.com',        created: 'Apr 1, 2021',  totalVolume: '$67,500', transactions: 55, lastTransaction: 'Feb 8, 2024',  paymentMethod: 'Mastercard •••• 2219' },
]
